import PlayerUI from '../../player-ui';
import iconStateLoading from '../../assets/icons/state-loading.svg';
import iconStateWaiting from '../../assets/icons/state-waiting.svg';
import iconStatePlaying from '../../assets/icons/state-waiting-playing.svg';
import iconStatePaused from '../../assets/icons/state-paused.svg';
import iconStateError from '../../assets/icons/state-error.svg';
import iconStateAdPlaying from '../../assets/icons/state-adplaying.svg';
import iconStateAdLoading from '../../assets/icons/state-adloading.svg';
import Component from './component';
import { supportsTouchInput } from '../utils/support';
import { updateTooltip } from '../utils/tooltip';

const stateIcons = {
  loading: iconStateLoading,
  playing: iconStatePlaying,
  paused: iconStatePaused,
  adplaying: iconStateAdPlaying,
  adloading: iconStateAdLoading,
  waiting: iconStateWaiting,
  error: iconStateError,
  empty: iconStatePaused,
  idle: iconStatePaused,
  notready: iconStatePaused
};

/**
 * Custom button component that changes it's icon and label depending on the state of the player
 */
export default class StateButton extends Component {
  constructor (props) {
    super(props);

    this.player = this.props.player;
    this.handleEvent = this.handleEvent.bind(this);
  }

  getDefaultProps () {
    const en = PlayerUI.getLocale('en');

    return {
      class: 'iono-state-button',
      iconClass: '',
      locale: en,
      paused: true,
      state: 'empty',
      player: null,
      label: en.player.play,
      icon: stateIcons.empty || iconStatePaused,
      onclick: function () {},
      showLabel: false
    };
  }

  /**
   * Update the state of the button
   *
   * @param {Object} state
   */
  setState (state) {
    if (state.state !== undefined) {
      this.props.state = state.state;
    }

    if (state.paused !== undefined) {
      this.props.paused = state.paused;
    }

    this.props.label = this.props.locale.player[this.props.paused ? 'play' : 'pause'];
    this.props.icon = stateIcons[this.props.state] || iconStatePaused;

    this.update();
  }

  /**
   * Handle player and ui events
   *
   * @param {Object} event
   */
  handleEvent (event) {
    switch (event.type) {
      case 'click':
        this.player && this.player.togglePlay();
        this.props.onclick(event);
        break;

      case 'touchtap':
        event.preventDefault();
        this.player && this.player.togglePlay();
        break;

      default:
        if (!this.player) return;
        if (this.player.getState() === 'adplaying') {
          this.setState({
            state: (event.type === 'adloading') ? 'adloading' : 'adplaying',
            paused: this.player.isPaused()
          });
        } else {
          this.setState({
            state: event.currentState,
            paused: this.player.isPaused()
          });
        }
        break;
    }
  }

  /**
   * Attach the component to a DOM element
   *
   * @param {DOMElement} element
   */
  attach (element) {
    super.attach(element);

    this.$element.addEventListener('click', this);

    if (supportsTouchInput()) {
      this.$element.addEventListener('touchtap', this);
    }

    if (this.props.player) {
      this.props.player.on('state', this.handleEvent);
      this.props.player.on('adplaylistload', this.handleEvent);
      this.props.player.on('adplaying', this.handleEvent);
    }
  }

  /**
   * Detach the component from a DOM element
   */
  detach () {
    if (this.isAttached()) {
      this.$element.removeEventListener('click', this);
      this.$element.removeEventListener('touchtap', this);

      if (this.props.player) {
        this.props.player.off('state', this.handleEvent);
        this.props.player.off('adplaylistload', this.handleEvent);
        this.props.player.off('adplaying', this.handleEvent);
      }
    }

    super.detach();
  }

  /**
   * Update the component ui
   */
  update () {
    if (!this.isAttached()) return;

    if (this.props.showLabel) this.$('.iono-button-label').textContent = this.props.label;
    this.$('.iono-state-button-icon').innerHTML = this.props.icon;
  }

  /**
   * Destroy the component
   */
  destroy () {
    this.detach();
  }

  render () {
    return `
      <button class="${this.props.class}">
        <span class="iono-state-button-icon" aria-hidden="true">${this.props.icon}</span>
        ${this.props.showLabel ? `<span class="iono-state-button-label">${this.props.label}</span>` : ''}
      </button>
    `;
  }
}
